'use client'

import { useState } from 'react'
import clsx from 'clsx'

import StudyProgress, { StudyProgressDetails, StudyProgressSingleStrings } from '/react4xp/components/StudyProgress'

import './index.scss'

export interface StudyProgressTab {
    title?: string
    studyProgress?: {
        title?: string
        details?: StudyProgressDetails[]
        singleStrings?: StudyProgressSingleStrings
    }
}

export interface StudyProgressTabsProps {
    className?: string
    tabs?: StudyProgressTab[]
}

export default function StudyProgressTabs({ className, tabs = [] }: StudyProgressTabsProps) {
    const [activeIndex, setActiveIndex] = useState(0)

    if (!tabs || tabs.length === 0) return null

    const safeIndex = activeIndex < tabs.length ? activeIndex : 0
    const activeTab = tabs[safeIndex]

    return (
        <div className={clsx('study-progress-tabs', className)}>
            <div className='container'>
                <div className='study-progress-tabs__tablist' role='tablist'>
                    {tabs.map((tab, i) => {
                        const tabId = `study-progress-tab-${i}`
                        const panelId = `study-progress-panel-${i}`
                        const isActive = i === safeIndex
                        return (
                            <button
                                key={tabId}
                                id={tabId}
                                type='button'
                                role='tab'
                                aria-selected={isActive}
                                aria-controls={panelId}
                                tabIndex={isActive ? 0 : -1}
                                className={clsx(
                                    'study-progress-tabs__tab h4',
                                    isActive && 'active'
                                )}
                                onClick={() => setActiveIndex(i)}
                            >
                                {tab.title}
                            </button>
                        )
                    })}
                </div>
            </div>

            {activeTab?.studyProgress && (
                <div
                    className='study-progress-tabs__panel'
                    role='tabpanel'
                    id={`study-progress-panel-${safeIndex}`}
                    aria-labelledby={`study-progress-tab-${safeIndex}`}
                    key={safeIndex}
                >
                    <StudyProgress
                        title={activeTab.studyProgress.title}
                        details={activeTab.studyProgress.details}
                        singleStrings={activeTab.studyProgress.singleStrings}
                    />
                </div>
            )}
        </div>
    )
}
